import React from 'react'
import * as Progress from '@radix-ui/react-progress'
import { cx } from 'class-variance-authority'

export const ProgressIndicator = ({
  progress,
  className,
}: {
  progress: number
  className: string
}) => {
  return (
    <Progress.Root
      className={cx(
        'h-4 w-full overflow-hidden rounded-lg border border-zinc-300 bg-zinc-100/80 shadow-md',
        className,
      )}
      style={{
        transform: 'translateZ(0)',
      }}
      value={progress}
    >
      <Progress.Indicator
        className="ease-[cubic-bezier(0.65, 0, 0.35, 1)] h-full w-full bg-primary-500 transition-transform"
        style={{ transform: `translateX(-${100 - progress}%)` }}
      />
    </Progress.Root>
  )
}
